import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Judcoco | Créations d'Emotes Personnalisées",
  description = "Créatrice d'emotes personnalisées pour Twitch, Discord, Tiktok et YouTube",
  pathname = "",
  keywords = "emotes twitch, emotes discord, emotes personnalisées, badges twitch, badges youtube, emotes tiktok, création emotes, dessin emotes, emotes sur mesure, emotes streamer, emotes stream, emotes animées, emotes chibi, emotes kawaii, emotes manga, emotes cartoon, badges personnalisés, commissions emotes, artiste emotes, design emotes",
  ogImage = "/favicon.ico"
}) => {
  const baseUrl = "https://judcoco.vercel.app";
  const currentUrl = `${baseUrl}${pathname}`;
  const fullImageUrl = `${baseUrl}${ogImage}`;

  return (
    <Helmet>
      {/* Tags de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph avec icône */}
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="64" />
      <meta property="og:image:height" content="64" />
      <meta property="og:image:alt" content="Icône Judcoco" />

      {/* Twitter Card avec icône */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content="Icône Judcoco" />

      {/* Autres meta tags importants */}
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="google" content="notranslate" />
      <meta name="google-site-verification" content="nIwINm53euMBLJNbUubBcAt4a-lXYzAoL0XRjhzd4Es" />
      
      {/* Langue */}
      <meta property="og:locale" content="fr_FR" />
      <link rel="alternate" href={currentUrl} hreflang="fr-fr" />
    </Helmet>
  );
};

export default SEO;